/* Product card colour swatches (task #1061)
   A click or tap on a swatch used to open the PDP. It now selects that colour on the card instead - image, ring
   and the card's links - so the next click on the image or title opens the PDP on that colour. Desktop still
   previews colours on hover (theme.js) and falls back to the selected colour when the mouse leaves the card.
   Covers both swatch types in snippets/product-grid-item.liquid: variant colours (grid-swatch) and sibling
   products (product-item-siblings). */
(function () {
  const selectors = {
    card: '[data-grid-item]',
    variantSwatch: 'grid-swatch [data-swatch-button]',
    siblingSwatch: 'product-item-siblings [data-sibling-link]',
  };
  const swatchSelector = `${selectors.variantSwatch}, ${selectors.siblingSwatch}`;
  const tapTolerance = 10;
  const pickedSiblings = new WeakMap();
  let tapStart = null;

  function selectVariantSwatch(swatch, card) {
    const swatchLink = swatch.querySelector('[data-swatch-link]');
    if (!swatchLink) return;

    // Same lookup as the theme's hover preview (GridSwatch.showVariantImage in theme.js)
    const variantName = (swatch.getAttribute('data-swatch-variant-name') || '').replaceAll('"', "'");
    card.querySelectorAll('[data-product-image] [data-variant-title]').forEach((image) => {
      image.classList.toggle('is-swatch-selected', image.getAttribute('data-variant-title') === variantName);
    });

    card.querySelectorAll('grid-swatch [data-swatch-link]').forEach((link) => {
      const isSelected = link === swatchLink;
      link.classList.toggle('is-selected', isSelected);
      if (isSelected) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    card.querySelectorAll('a[data-product-link]').forEach((productLink) => {
      productLink.href = swatchLink.href;
    });
  }

  function showSibling(swatch) {
    // The theme's hover preview (SiblingSwatches.showSibling in theme.js) swaps the image, price, cutline and links
    swatch.dispatchEvent(new MouseEvent('mouseenter'));
    // ...which also pins the swatch tooltip, and no real mouseleave may come to unpin it
    swatch.dispatchEvent(new MouseEvent('mouseleave'));
  }

  function selectSiblingSwatch(swatch, card) {
    showSibling(swatch);

    // Move the theme's ring to the selected colour
    card.querySelectorAll('product-item-siblings .sibling__link').forEach((link) => {
      link.classList.toggle('sibling__link--current', swatch.contains(link));
    });

    pickedSiblings.set(card, swatch);
  }

  function selectSwatch(swatch) {
    const card = swatch.closest(selectors.card);
    if (!card) return;

    if (swatch.matches(selectors.siblingSwatch)) {
      selectSiblingSwatch(swatch, card);
    } else {
      selectVariantSwatch(swatch, card);
    }
  }

  document.addEventListener(
    'touchstart',
    (event) => {
      const touch = event.touches[0];
      const swatch = event.target.closest(swatchSelector);
      tapStart = swatch && event.touches.length === 1 ? { x: touch.clientX, y: touch.clientY, swatch } : null;
    },
    { passive: true }
  );

  // Handled on touchend, not click: cancelling it stops the emulated mouse events too. Otherwise iOS can treat
  // the first tap as a hover (the theme's mouseenter swaps the image) and never send the click.
  document.addEventListener(
    'touchend',
    (event) => {
      const start = tapStart;
      tapStart = null;
      if (!start) return;

      const touch = event.changedTouches[0];
      const moved = Math.abs(touch.clientX - start.x) > tapTolerance || Math.abs(touch.clientY - start.y) > tapTolerance;
      if (moved || event.target.closest(swatchSelector) !== start.swatch) return;

      event.preventDefault();
      selectSwatch(start.swatch);
    },
    { passive: false }
  );

  // Desktop clicks, plus touch browsers that still send a click. Capture phase, so it runs before the theme's
  // sibling click handler (which opens the PDP) and a stopPropagation elsewhere can't let the link through.
  document.addEventListener(
    'click',
    (event) => {
      const swatch = event.target.closest(swatchSelector);
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();
      selectSwatch(swatch);
    },
    true
  );

  // When the mouse leaves a sibling card (or, on touch, the shopper taps elsewhere), the theme resets the card to
  // its own product. Once a colour is selected, go back to that colour instead. mouseleave doesn't bubble, so
  // this has to be capture phase. Variant cards need nothing here: their selected image is a separate class.
  document.addEventListener(
    'mouseleave',
    (event) => {
      const picked = event.target instanceof Element ? pickedSiblings.get(event.target) : null;
      if (!picked) return;

      event.stopPropagation();
      showSibling(picked);
    },
    true
  );
})();
